import styled from 'styled-components';
import {useContext} from 'react';
import {InitializeParamsContext} from '../../store/context/context';

const FindAnotherOrder = () => {
    const Button = styled.div`
        color: #0000ff;
        font-weight: bold;
        text-transform: uppercase;
        cursor: pointer;
        width: max-content;
    `;
    const userAuth = useContext(InitializeParamsContext).userAuth;
    const handleClick = () => {
        if (userAuth) {
            window.location.href =
                window.location.protocol + '//' + window.location.hostname + '/personal/track_order/';
        } else {
            window.location.href = window.location.href.split('?')[0];
        }
    };

    return (
        <>
            <Button onClick={handleClick}>Проверить другой заказ</Button>
        </>
    );
};

export {FindAnotherOrder};
